import axios from 'axios'

export default {
    async create(model) {
        return await axios.post(`service`, model)
    },
    async fetchById(id) {
        return await axios.get(`service/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`service?q=${query}&page=${page}`)
    },
    async fetchCart() {
        return await axios.get(`service/fetch-cart`)
    },
    async fetchCategory(query, page) {
        return await axios.get(`service/fetch-category?q=${query}&page=${page}`)
    },
    async fetchItem(query,page,id){
        return await axios.get(`service/fetch-items?q=${query}&page=${page}&id=${id}`)
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`service/${id}`, model)
    },
    async AddToCart(items){
        return await axios.post(`service/add-to-cart`,items);
    },
    async EditToCart(item){
        return await axios.post(`service/edit-to-cart`,item);
    },
    async delete(id) {
        return await axios.delete(`service/${id}`)
    },
    async DeleteCart(id) {
        return await axios.delete(`service/delete-cart/${id}`)
    },
    async createOrderFromCartService(order){
        return await axios.post(`service/create-order-service`, order)
    },
    async requestService(item){
        return await axios.post(`service/request-service`,item);
    },
  
   
}
